import type { UnknownOutputParams } from 'expo-router'
import type { ReactNode } from 'react'

import type { TEventOriginParam } from '@/src/general/constants/routes'
import { PUBLICATION_TRACKING_SOURCE, TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'

import { CommunityActionButton } from './CommunityActionButton/CommunityActionButton'
import { CommunityScreenLayout } from './CommunityScreenLayout'

type TCommunityPendingScreenProps = TEventOriginParam & {
  id: number
  action?: string
  searchParams: UnknownOutputParams
}

const noop = () => {}

export const CommunityPendingScreen = ({
  id,
  action,
  origin,
  searchParams,
}: TCommunityPendingScreenProps): ReactNode => (
  <CommunityScreenLayout
    id={id}
    action={action}
    searchParams={searchParams}
    community={undefined}
    subscription={undefined}
    listProps={{
      publications: undefined,
      isPending: true,
      isFetchingNextPage: false,
      hasNextPage: false,
      fetchNextPage: noop,
    }}
  >
    <CommunityActionButton
      communityId={id}
      community={undefined}
      course="page"
      origin={origin}
      source={TRACKING_SOURCE.COMMUNITY_PAGE}
      publicationTrackingSource={PUBLICATION_TRACKING_SOURCE.COMMUNITY_READ_MORE}
    />
  </CommunityScreenLayout>
)
